<p>salesman-analysis works!</p>
